import { OnInit, EventEmitter } from '@angular/core';
var AcStars = /** @class */ (function () {
    function AcStars() {
        this.rate = new EventEmitter();
        this.stars = [1, 2, 3, 4, 5];
        this._rating = 0;
        var count = this.starCount < 0 ? 5 : this.starCount;
    }
    AcStars.prototype.ngOnInit = function () {
        this._rating = this.rating;
    };
    AcStars.prototype.onRate = function (star) {
        if (!this.readonly) {
            this.rate.emit(star);
            this._rating = star;
        }
    };
    return AcStars;
}());
export { AcStars };
//# sourceMappingURL=stars.js.map